import { render, staticRenderFns } from "./forget_reply.vue?vue&type=template&id=4fa73c68&scoped=true&"
import script from "./forget_reply.vue?vue&type=script&lang=js&"
export * from "./forget_reply.vue?vue&type=script&lang=js&"
import style0 from "./forget_reply.vue?vue&type=style&index=0&id=4fa73c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa73c68",
  null
  
)

export default component.exports